export function randomString() {
	return Math.random().toString(36).slice(2);
}

/*Object.defineProperty(Object.prototype, "copyJson", {
	enumerable: false,
	value: function() {
		return JSON.parse(JSON.stringify(this));
	}
});*/

/**
 * @param {Array} a
 * @param {number=} count
 * @returns {Array}
 */
function copyArray(a, count) {

	if(count && count > 0) {
		return a.slice(0, count);
	}

	return a.slice(0);
}

/**
 * Shuffles array in place.
 * @param {Array} a items The array containing the items.
 */
function shuffleArray(a) {
    var j, x, i;
    for (i = a.length; i; i--) {
        j = Math.floor(Math.random() * i);
        x = a[i - 1];
        a[i - 1] = a[j];
        a[j] = x;
    }

	return a;
}

/**
 * @param {Array} arr
 * @param {number} index
 * @returns {number}
 */
export function arrayCircleGetIndex(arr, index) {
	var idx = index % arr.length;
	if(idx < 0) {
		idx = idx + arr.length;
	}
	return idx + 0;
}

/*Object.defineProperty(Array.prototype, "circleGetIndex", {
    'enumerable': false,
    'value': function(index) {
        var idx = index % this.length;
        if(idx < 0) {
            idx = idx + this.length;
        }
        return idx + 0;
    }
});*/

export function arrayCircleGetElement(arr, index) {
	return arr[arrayCircleGetIndex(arr, index)];
}

/*Object.defineProperty(Array.prototype, "circleGetElement", {
    'enumerable': false,
    'value': function(index) {
        return this[this.circleGetIndex(index)];
    }
});*/

function arrayCircleGetElements(arr, fromIndex, count) {
	var arrayTmp = [];

	for(var i = 0; i < Math.abs(count); i++) {

		var idx = i;

		if(count < 0) {
			idx = i * -1;
		}

		arrayTmp.push(arrayCircleGetElement(arr, fromIndex + idx));
	}

	return arrayTmp;
}

/*Object.defineProperty(Array.prototype, "circleGetElements", {
    'enumerable': false,
    'value': function(fromIndex, count) {
        var arrayTmp = [];

        for(var i = 0; i < Math.abs(count); i++) {

            var idx = i;

            if(count < 0) {
                idx = i * -1;
            }

            arrayTmp.push(this.circleGetElement(fromIndex + idx));
            //arrayTmp.push(this[this.circleGetIndex(fromIndex + idx)]);
        }

        return arrayTmp;
    }
});*/

function getArrayRandValue(arr) {
	return arr[Math.floor(Math.random() * arr.length)];
}

function stackTrace() {
    var err = new Error();
    return err.stack;
}

/*function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}*/

/**
 * Returns a random integer between min (inclusive) and max (inclusive)
 * @param {Number|number} min
 * @param {Number|number} max
 */
function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getRandomAngle() {
    return getRandomInt(-180, 180);
}

function getRandRadius(diameter) {

	var dir = Math.random() >= 0.5 ? -1 : 1;

	return getRandomInt(0, diameter / 2) * dir;
}

/**
 * Returns a random float between min (inclusive) and max (exclusive)
 * @param {number} min
 * @param {number} max
 */
function getRandomFloat(min, max) {
	return Math.random() * (max - min) + min;
}

/**
 * @returns {boolean}
 */
function getRandomBoolean() {
    return Math.random() >= 0.5;
}

function getMaxOfArray(numArray) {
  return Math.max.apply(null, numArray);
}

function getMinOfArray(numArray) {
  return Math.min.apply(null, numArray);
}

function randomProperty(obj) {
    var keys = Object.keys(obj);
    return obj[keys[ keys.length * Math.random() << 0]];
};